import { render } from "./SettingLayout.vue?vue&type=template&id=6172cc22&scoped=true"
import script from "./SettingLayout.vue?vue&type=script&lang=js"
export * from "./SettingLayout.vue?vue&type=script&lang=js"

import "./SettingLayout.vue?vue&type=style&index=0&id=6172cc22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6172cc22"]])

export default __exports__